module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmall.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmall.png
// module id = 254
// module chunks = 0